// eslint-disable-next-line no-unused-vars
import React from 'react';

const pushFindEmployeesEvent = (label = '', data = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'eventCategory': ['search'],
    'eventAction': ['find employees'],
    'email_id': [data.email ?? ''],
    'eventLabel': [label],
    'search_result_radius': [data.radius ?? ''],
    'search_result_experience': [data.experience ?? ''],
    'search_result_amount': [data.searchResultAmount ?? ''],
    'search_result_zip_code': [data.location ?? ''],
    'search_result_keyword': [data.keyword ?? ''],
    'hs_contact_id': [data.hsObjectId ?? ''],
    'event': 'eventTracker',
  });

  window.dataLayer.push({event_params: null});
  window.dataLayer.push({
    'event': 'interaction',
    'event_params': {
      'event_name': 'employee_search',
      'action': label,
    },
  });
};

const pushFindEmployeesFormSubmitEvent = (label = '', data = {}) => {
  let dataLayer = {
    'eventCategory': ['form'],
    'eventAction': ['form submission'],
    'eventLabel': [label],
    'email_id': [data.email ?? ''],
    'form_name': [data.formName ?? ''],
    'form_type': [data.formType ?? ''],
    'form_guid': [data.formGuid ?? ''],
    'hs_contact_id': [data.hsObjectId ?? ''],
    'event': 'eventTracker',
  };

  if (data.talentFormSubmission) {
    dataLayer = {
      ...dataLayer,
      'talent_form_submission': '1',
    };
  }
  if (data.clientFormSubmission) {
    dataLayer = {
      ...dataLayer,
      'client_form_submission': '1',
    };
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayer);
};

export {pushFindEmployeesEvent, pushFindEmployeesFormSubmitEvent};
